/**
 * Created by f.putra on 2019-07-02.
 */
export const numberWithCommas = (x) => {
    if (x !== null) {
        if (x !== undefined) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return 0
        }
    }
    return 0
}

export const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

export const queryStringBuilder = (payload) => {
    var esc = encodeURIComponent;
    return Object.keys(payload)
        .map((k) => esc(k) + '=' + esc(payload[k]))
        .join('&');
};

export const loadState = (key) => {
    try {
        const serializedState = localStorage.getItem(key);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const saveState = (key, value) => {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
    }
};

export const baseUrl = (memberType) => {
    // https://a1.omipos.id:8091/aeon_jgc/
    // https://a1.omipos.id:8092/aeon_bsd/
    // https://a1.omipos.id:8093/aeon_sentul/
    switch (memberType) {
        case process.env.REACT_APP_ENV === 'development' ? "0b8b63c7-5dc8-44ea-a31e-93bb9bfb9199" : "3ffef6f1-9185-4e8d-94cd-3a1b26d5dfc2":
            return process.env.REACT_APP_ENV === 'development' ? "https://demo.omipos.id:8443/aeon_jgc/" : "https://a1.omipos.id:8091/aeon_jgc/"
        case process.env.REACT_APP_ENV === 'development' ? "40a941b0-3b5c-45fd-b036-6668d0d314b5" : "d0295939-11cb-41dc-8ce8-ae3627539678":
            return process.env.REACT_APP_ENV === 'development' ? "https://demo.omipos.id:8443/aeon_bsd/" : "https://a1.omipos.id:8092/aeon_bsd/"
        case process.env.REACT_APP_ENV === 'development' ? "2eb2ebde-f0b1-4bd3-9b28-6a4446bc3864" : "d9f9da72-6001-4a65-b118-37e01c4265ee":
            return process.env.REACT_APP_ENV === 'development' ? "https://demo.omipos.id:8443/aeon_sentul/" : "https://a1.omipos.id:8093/aeon_sentul/"
        case process.env.REACT_APP_ENV === 'development' ? "1f36bff1-eec6-4c95-b4de-98037010a2f9" : "8730c3e9-fefe-4c90-a23e-db1439be2133":
            return process.env.REACT_APP_ENV === 'development' ? "https://demo.omipos.id:8443/aeon_tjb/" : "https://a1.omipos.id:8094/aeon_tjb/"
        default:
            break;
    }
}

export const imageUrl = (memberType) => {
    switch (memberType) {
        case process.env.REACT_APP_ENV === 'development' ? "0b8b63c7-5dc8-44ea-a31e-93bb9bfb9199" : "3ffef6f1-9185-4e8d-94cd-3a1b26d5dfc2":
            return process.env.REACT_APP_ENV === 'development' ? "https://demo.omipos.id:8443/" : "https://a1.omipos.id:8091/"
        case process.env.REACT_APP_ENV === 'development' ? "40a941b0-3b5c-45fd-b036-6668d0d314b5" : "d0295939-11cb-41dc-8ce8-ae3627539678":
            return process.env.REACT_APP_ENV === 'development' ? "https://demo.omipos.id:8443/" : "https://a1.omipos.id:8092/"
        case process.env.REACT_APP_ENV === 'development' ? "2eb2ebde-f0b1-4bd3-9b28-6a4446bc3864" : "d9f9da72-6001-4a65-b118-37e01c4265ee":
            return process.env.REACT_APP_ENV === 'development' ? "https://demo.omipos.id:8443/" : "https://a1.omipos.id:8093/"
        case process.env.REACT_APP_ENV === 'development' ? "1f36bff1-eec6-4c95-b4de-98037010a2f9" : "8730c3e9-fefe-4c90-a23e-db1439be2133":
            return process.env.REACT_APP_ENV === 'development' ? "https://demo.omipos.id:8443/" : "https://a1.omipos.id:8094/"
        default:
            break;
    }
}

export const locationMall = (memberType) => {
    switch (memberType) {
        case process.env.REACT_APP_ENV === 'development' ? "40a941b0-3b5c-45fd-b036-6668d0d314b5" : "d0295939-11cb-41dc-8ce8-ae3627539678":
            return "bsd"
        case process.env.REACT_APP_ENV === 'development' ? "2eb2ebde-f0b1-4bd3-9b28-6a4446bc3864" : "d9f9da72-6001-4a65-b118-37e01c4265ee":
            return "sentul"
        case process.env.REACT_APP_ENV === 'development' ? "1f36bff1-eec6-4c95-b4de-98037010a2f9" : "8730c3e9-fefe-4c90-a23e-db1439be2133":
            return "tjb"
        default:
            return "jgc"
    }
}

export const mallDefinition = (memberType) => {
    switch (memberType) {
        case process.env.REACT_APP_ENV === 'development' ? "40a941b0-3b5c-45fd-b036-6668d0d314b5" : "d0295939-11cb-41dc-8ce8-ae3627539678":
            return "AEON MALL BSD"
        case process.env.REACT_APP_ENV === 'development' ? "2eb2ebde-f0b1-4bd3-9b28-6a4446bc3864" : "d9f9da72-6001-4a65-b118-37e01c4265ee":
            return "AEON MALL SENTUL CITY"
        case process.env.REACT_APP_ENV === 'development' ? "1f36bff1-eec6-4c95-b4de-98037010a2f9" : "8730c3e9-fefe-4c90-a23e-db1439be2133":
            return "AEON MALL TJB"
        case process.env.REACT_APP_ENV === 'development' ? "0b8b63c7-5dc8-44ea-a31e-93bb9bfb9199" : "3ffef6f1-9185-4e8d-94cd-3a1b26d5dfc2":
            return "AEON MALL JGC"
        default:
            return null
    }
}

export const deeplinkMall = (memberType) => {
    switch (memberType) {
        case process.env.REACT_APP_ENV === 'development' ? "40a941b0-3b5c-45fd-b036-6668d0d314b5" : "d0295939-11cb-41dc-8ce8-ae3627539678":
            return "BSD"
        case process.env.REACT_APP_ENV === 'development' ? "2eb2ebde-f0b1-4bd3-9b28-6a4446bc3864" : "d9f9da72-6001-4a65-b118-37e01c4265ee":
            return "SENTUL"
        case process.env.REACT_APP_ENV === 'development' ? "1f36bff1-eec6-4c95-b4de-98037010a2f9" : "8730c3e9-fefe-4c90-a23e-db1439be2133":
            return "TJB"
        case process.env.REACT_APP_ENV === 'development' ? "0b8b63c7-5dc8-44ea-a31e-93bb9bfb9199" : "3ffef6f1-9185-4e8d-94cd-3a1b26d5dfc2":
            return "JGC"
        default:
            return null
    }
}

export const transactionUrl = (memberType) => {
    switch (memberType) {
        case process.env.REACT_APP_ENV === 'development' ? "40a941b0-3b5c-45fd-b036-6668d0d314b5" : "d0295939-11cb-41dc-8ce8-ae3627539678":
            return "bsd/iems/transaction"
        case process.env.REACT_APP_ENV === 'development' ? "2eb2ebde-f0b1-4bd3-9b28-6a4446bc3864" : "d9f9da72-6001-4a65-b118-37e01c4265ee":
            return "sentul/iems/transaction"
        case process.env.REACT_APP_ENV === 'development' ? "1f36bff1-eec6-4c95-b4de-98037010a2f9" : "8730c3e9-fefe-4c90-a23e-db1439be2133":
            return "tjb/iems/transaction"
        case process.env.REACT_APP_ENV === 'development' ? "0b8b63c7-5dc8-44ea-a31e-93bb9bfb9199" : "3ffef6f1-9185-4e8d-94cd-3a1b26d5dfc2":
            return "jgc/iems/transaction";
        default:
            return null;
    }
}
